<template><ReportFormSteps :sfc_code="$route.query.company_id" :annual_report="$route.query.annual_report"></ReportFormSteps></template>
<script>
import ReportFormSteps from "@/components/Dashboard/FCO/Reports/ReportFormSteps.vue";
export default {
  name: "reportFormSteps",
  components: { ReportFormSteps },
};
</script>
